<script setup lang="ts">
import FormLabel from '@/components/FormLabel/FormLabel.vue';
import { getPrefixedUuid } from '@/components/forms/utils';
import { computed, useAttrs } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{
  id?: string;
  label?: string;
  items?: string[];
  loading?: boolean;
  disabled?: boolean;
  errorMessage?: string;
  hint?: string;
  persistentHint?: boolean;
  infoMessage?: string;
}>();

const emit = defineEmits<{
  focus: [event: FocusEvent];
  blur: [event: FocusEvent];
}>();

const modelValue = defineModel<string | null | undefined>();

const id = props.id ?? getPrefixedUuid('combobox');

const attrs = useAttrs();
const passdownAttrs = computed(() => ({ ...attrs, class: undefined }));
</script>

<template>
  <div class="combobox" :class="$attrs.class">
    <FormLabel :for="id" :infoMessage="infoMessage" :label="label" :disabled="disabled">
      <template #default="{ onBlur, onFocus, hoverProps }">
        <v-combobox
          v-model="modelValue"
          v-bind="{ ...passdownAttrs, ...hoverProps, id }"
          :items="items"
          :loading="loading"
          :disabled="disabled"
          :error="Boolean(errorMessage)"
          :hint="errorMessage || hint"
          :persistentHint="Boolean(errorMessage) || persistentHint"
          :hideDetails="!errorMessage && !hint"
          density="compact"
          hideNoData
          @focus="
            emit('focus', $event);
            onFocus();
          "
          @blur="
            emit('blur', $event);
            onBlur();
          "
        />
      </template>
    </FormLabel>
  </div>
</template>
